
    <template>
      <section class="content element-doc">
        <h2 id="an-niu-shan-chu-er-ci-que-ren"><a class="header-anchor" href="#an-niu-shan-chu-er-ci-que-ren">¶</a> 按钮删除二次确认</h2>
<h3 id="wan-zheng-gong-neng"><a class="header-anchor" href="#wan-zheng-gong-neng">¶</a> 完整功能</h3>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;sh-del-button @confirm=&quot;onDelConfirm&quot; @cancel=&quot;onDelCancel&quot; delTipsShow :delTipsOptions=&quot;delTipsOptions&quot;&gt;删除&lt;/sh-del-button&gt;
  &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    data() {
      return {
        delTipsOptions: {
          type: 'success',
          message: '删除成功'
        }
      }
    },
    methods: {
      onDelCancel(v) {
        console.log('取消删除回调')
      },
      onDelConfirm() {
        console.log('点击了删除按钮')
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="shu-xing"><a class="header-anchor" href="#shu-xing">¶</a> 属性</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>message</td>
<td>提示信息</td>
<td>String</td>
<td>-</td>
<td>确定删除吗？</td>
</tr>
<tr>
<td>confirm-options</td>
<td>提示配置信息</td>
<td>object</td>
<td>-</td>
<td>{&quot;title&quot;: '提示',&quot;type&quot;: 'warning',&quot;showCancelButton&quot;: true,&quot;confirmButtonText&quot;: '确定',&quot;cancelButtonText&quot;: '取消'}</td>
</tr>
<tr>
<td>del-tips-show</td>
<td>是否显示删除成功信息</td>
<td>boolean</td>
<td>true,false</td>
<td>true</td>
</tr>
<tr>
<td>cancel-tips-show</td>
<td>是否显示取消提示信息</td>
<td>boolean</td>
<td>true,false</td>
<td>false</td>
</tr>
<tr>
<td>del-tips-options</td>
<td>删除成功提示配置信息,详细配置查看相应文档</td>
<td>object</td>
<td>-</td>
<td>{type:'success',message:'删除成功'}</td>
</tr>
<tr>
<td>cancel-tips-options</td>
<td>取消提示配置信息</td>
<td>object</td>
<td>-</td>
<td>{type:'success',message:'取消成功'}</td>
</tr>
</tbody>
</table>
<h3 id="shi-jian"><a class="header-anchor" href="#shi-jian">¶</a> 事件</h3>
<table>
<thead>
<tr>
<th>事件名</th>
<th>说明</th>
<th>返回值</th>
</tr>
</thead>
<tbody>
<tr>
<td>confirm</td>
<td>点击删除按钮触发</td>
<td>-</td>
</tr>
<tr>
<td>cancel</td>
<td>点击取消按钮触发</td>
<td>-</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('sh-del-button',{attrs:{"delTipsShow":"","delTipsOptions":_vm.delTipsOptions},on:{"confirm":_vm.onDelConfirm,"cancel":_vm.onDelCancel}},[_vm._v("删除")])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        delTipsOptions: {
          type: 'success',
          message: '删除成功'
        }
      }
    },
    methods: {
      onDelCancel(v) {
        console.log('取消删除回调')
      },
      onDelConfirm() {
        console.log('点击了删除按钮')
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  